/**
 * 防成谜
 *   输入框实名认证
 * */
import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Button, Modal, Checkbox, Form, Input, message } from 'antd';
import Util from '../../../script/util';
import WEBIM from '../../../store/WebNim';
import HTTP from '../../../script/service';
import IframeModal from '../../iframModal/IframModal';
import './IDCardAuth.scss';

const FormItem = Form.Item;

const IDCardAuth = (props) => {
  const { base } = props;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { resetFields } = form;
  const iframeElement = useRef(null);
  const [isAgree, setIsAgree] = useState(false);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    hideModal();

    WEBIM.onConfigFn('OPEN_ADDICTION_VERIFIED', () => {
      dispatch({
        type: 'change_id_card_auth_modal',
        data: { visibleIDCardAuth: true },
      });
    });
  }, []);

  // 提交认证
  const handleSubmit = (values) => {
    const { uid } = base;

    const params = { ...values, uid };
    HTTP._post_cert_secure_indulge(params)
      .then((res) => {
        if (res?.code === 200) {
          message.success('认证成功');
          resetFields();
          hideModal();
        } else {
          message.warning(res?.message || '认证失败，请稍后重试哦~');
        }
      })
      .catch((err) => {
        message.error('认证失败，请稍后重试哦~');
      });
  };

  // 重置状态
  const hideModal = () => {
    dispatch({
      type: 'change_id_card_auth_modal',
      data: { visibleIDCardAuth: false },
    });
  };

  // 同意协议
  const onChangeCheckbox = (checkbox) => {
    setIsAgree(checkbox.target.checked);
  };

  // 校验身份证号是否正确
  const checkIDCardAccount = (rule, value, callback) => {
    if (!value) {
      callback();
    } else if (value?.length < 18 || value?.length > 18) {
      callback('请填写正确的身份证号');
    } else {
      let birthday = value.substr(6, 8);
      birthday =
        birthday.slice(0, 4) +
        '-' +
        birthday.slice(4, 6) +
        '-' +
        birthday.slice(6);
      const age = Util.birthdayCalcAge(birthday);

      if (age < 18) {
        callback('请提供18岁到45岁之间的身份证信息');
      } else {
        callback();
      }
    }
  };

  // 打开协议 1: 用户协议 2: 隐私政策
  const openXieyi = (url) => {
    const {
      base: { rootConfig },
    } = this.props;
    const mobilePath = rootConfig?.protocolPath || rootConfig.mobilePath;
    let modalurl = mobilePath + url + '?v=' + rootConfig.version;

    iframeElement.current.showModal(modalurl, { zIndex: 9999 });
  };

  return (
    <Modal
      open={base?.visibleIDCardAuth}
      wrapClassName="daidai-modal-style has-top-border id-card-auth"
      centered={true}
      title="实名认证"
      footer={null}
      keyboard={false}
      maskClosable={false}
      width={410}
      onCancel={hideModal}
      zIndex={9998}
    >
      <div className="real-tip-icon" />
      <p className="real-tip-text">
        应国家法律法规要求，响应未成年人保护号召，进行该操作需进行账号实名，保障账号安全，防止账号被非法盗用或违规使用。
      </p>
      <Form form={form} layout="inline" onFinish={handleSubmit}>
        <FormItem
          label="真实姓名"
          name="certName"
          rules={[{ required: true, message: '请输入姓名' }]}
        >
          <Input placeholder="请输入姓名" />
        </FormItem>
        <FormItem
          label="身份证号"
          name="certNo"
          rules={[
            { required: true, message: '请输入身份证号' },
            { validator: checkIDCardAccount },
          ]}
        >
          <Input placeholder="请输入身份证号" />
        </FormItem>
        <FormItem>
          <p className="alert-tip">
            注意：实名认证信息与账号使用主体具有一致性，认证后不可修改
          </p>
        </FormItem>
        <FormItem>
          <Button
            className="daidai-btn-primary"
            disabled={!isAgree}
            htmlType="submit"
          >
            同意协议并认证
          </Button>
        </FormItem>
      </Form>
      <div className="real-xieyi">
        <Checkbox checked={isAgree} onChange={onChangeCheckbox}>
          已阅读并同意
          <Button type="link" onClick={() => openXieyi('/realname/index.html')}>
            《实名认证服务协议》
          </Button>
        </Checkbox>
      </div>
      {/* H5弹窗 */}
      <IframeModal wrappedComponentRef={iframeElement} />
    </Modal>
  );
};

export default connect((store) => ({ base: store }))(IDCardAuth);
